import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const DocumentUrl = `${Base_Url}/Document`;

export const GetModuleDocumentCartList = async (params) => {
  const res = await postApiWithAuthorization(
    `${DocumentUrl}/GetModuleDocumentCartList`,
    params
  );
  return res;
};

export const GetModuleDocumentList = async (params) => {
  const res = await postApiWithAuthorization(
    `${DocumentUrl}/GetModuleDocumentList`,
    params
  );
  return res;
};

export const UploadCustomerDocument = async (
  DocName,
  DocumentTypeID,
  AdminKeyID,
  params
) => {
  const res = await postApiWithAuthorization(
    `${DocumentUrl}/UploadCustomerDocument?DocName=${DocName}&DocumentTypeID=${DocumentTypeID}&AdminKeyID=${AdminKeyID}`,
    params
  );
  return res;
};

export const UploadFile = async (
  ModuleName,
  DocName,
  DocumentTypeID,
  AdminKeyID,
  ModuleKeyID,
  params
) => {
  const res = await postApiWithAuthorization(
    `${DocumentUrl}/UploadFile?ModuleName=${ModuleName}&DocName=${DocName}&DocumentTypeID=${DocumentTypeID}&AdminKeyID=${AdminKeyID}&ModuleKeyID=${ModuleKeyID}`,
    params
  );
  return res;
};

export const DeleteDocument = async (ModuleName, DocID) => {
  const res = await getApiWithAuthorization(
    `${DocumentUrl}/DeleteDocument?ModuleName=${ModuleName}&DocID=${DocID}`
  );
  return res;
};
